/**
 * 서류·템플릿 화면. 세분류로 진입을 나누지 않는다.
 */
const SubMatGClientRouteGuard = ({ children }) => children;

export default SubMatGClientRouteGuard;
